/*
 * http://threedubmedia.com/code/event/drag
 * */
(function () {
  "use strict";

  mfDragManager.$inject = ['$parse', '$window'];
  angular
    .module('trainerWebApp.directives')
    .directive('mfDragManager', mfDragManager);

  function mfDragManager($parse, $window) {
    return {
      restrict: 'A',
      scope: {
        scopeDragDropFunction: '&mfDragDrop',
        scopeDragStartFunction: '&mfDragBegin',
        dragResolveFn: '&mfDragResolve'
      },
      link: function (scope, iElement, iAttrs) {

        var dragInitiator;
        var isDragging = false;
        var lastDragEnterTarget;
        var dragOffsetData;
        var dropOverElements = [];
        var defaultDragProxyOffset = {};
        var isIE = $window.BrowserDetect.browser === 'Explorer';

        var dragProxyElementId = "#" + iAttrs['mfDragManager'];
        var seriesDropPositionId = "#seriesDropPosition";
        var seriesDropPositionTopId = "#seriesDropPositionTop";
        var dragProxy = iElement.find(dragProxyElementId);
        defaultDragProxyOffset = dragProxy.offset();
        var seriesDropPosition = iElement.find(seriesDropPositionId);
        var seriesDropPositionTop = iElement.find(seriesDropPositionTopId);

        function showDragProxy() {
          if (!dragProxy) {
            return;
          }

          dragProxy.css('opacity', 1);
        }

        function hideDragProxy() {
          if (!dragProxy) {
            return;
          }

          dragProxy.css('opacity', 0);

          dragProxy.offset({
            left: defaultDragProxyOffset.left,
            top: defaultDragProxyOffset.top
          });
        }

        function initDragOffsetData(position, offset) {
          dragOffsetData =
          {
            left: position.x - offset.left,
            top: position.y - offset.top
          };
        }

        function getElementUnder(event, attrName) {
          var target = event.target || event.srcElement;
          return angular.element(target).closest("[" + attrName + "]");
        }

        function setDragProxyPosition(position) {
          if (!dragProxy) {
            return;
          }

          dragProxy.offset({
            left: position.x - dragOffsetData.left,
            top: position.y - dragOffsetData.top
          });
        }

        function getDragItem(from) {
          var data = from.data('dragItem');
          if (!data && scope.dragResolveFn) {
            data = scope.dragResolveFn({id: from.data('dragItemId')});
          }
          return data;
        }


        function dragStart(event) {
          if (isDragging) {
            event.preventDefault();
            return;
          }

          dragInitiator = getElementUnder(event, 'drag-start');

          var elementOffset = dragInitiator.offset();

          var dragInitiatorData = getDragItem(dragInitiator);

          if (!dragInitiator.hasClass('active-course')) {
            event.preventDefault();
            return;
          }

          setDraggingCursor();

          scope.$apply(function () {
            scope.scopeDragStartFunction({$dragEvent: dragInitiatorData});
          });

          var position = {
            x: event.pageX,
            y: event.pageY
          };

          dragProxy.width(dragInitiator.width());

          initDragOffsetData(position, elementOffset);

          event.preventDefault();

          if (dragInitiatorData.type === 'course') {
            dragInitiator.removeClass('active-course');
            dragInitiator.addClass('hideMe');
          } else {
            dragInitiator.hide();
          }

          isDragging = true;

          setDragProxyPosition(position);

          showDragProxy();

          if (isIE) {
            collectDropOverElements();
          }
        }

        function setDraggingCursor() {
          if (!!['Chrome', 'Safari'].indexOf($window.BrowserDetect.browser)) {
            document.body.style.cursor = '-webkit-grabbing';
          } else if ($window.BrowserDetect.browser === 'Firefox') {
            document.body.style.cursor = '-moz-grabbing';
          }

          $('.active-course').addClass('dragging');
        }

        function clearDraggingCursor() {
          document.body.style.cursor = 'default';
          $('.active-course').removeClass('dragging');
        }

        function collectDropOverElements() {
          var elems = angular.element('[drag-over]');

          dropOverElements = _.map(elems, function (e) {
            var el = angular.element(e);
            var data = getDragItem(el);

            return {
              item: el,
              sort: data.type === 'seriesCourse' ? 1 : 2
            }
          });

          dropOverElements = _.sortBy(dropOverElements, function (s) {
            return s.sort;
          });
        }

        function getElementFromDropOverElements(event) {
          var pageX = event.pageX;
          var pageY = event.pageY;

          var result = null;

          var el;
          var left;
          var right;
          var top;
          var bottom;
          for (var index = 0; index < dropOverElements.length; index++) {
            el = dropOverElements[index];
            left = el.item.offset().left;
            right = left + el.item.outerWidth();
            top = el.item.offset().top;
            bottom = top + el.item.outerHeight();
            if (left <= pageX && top <= pageY && right >= pageX && bottom >= pageY) {
              result = el.item;
              break;
            }
          }
          return result;
        }

        function drag(event) {
          if (!isDragging) return;

          event.preventDefault();

          var position = {
            x: event.pageX,
            y: event.pageY
          };

          setDragProxyPosition(position);


          var target = isIE ? getElementFromDropOverElements(event) : getElementUnder(event, 'drag-over');

          if (!target) {
            return;
          }

          var targetItemData = getDragItem(target);

          if (lastDragEnterTarget && lastDragEnterTarget.get(0) != target.get(0)) {

            var itemData = getDragItem(lastDragEnterTarget);

            if (itemData.type === 'seriesCourse') {
              lastDragEnterTarget.css('border-top', 'none');
              lastDragEnterTarget.css('border-bottom', 'none');
            } else if (itemData.type === 'seriesList') {
              seriesDropPosition.hide();
            } else if (itemData.type === 'seriesListTop') {
              seriesDropPositionTop.hide();
            }

            lastDragEnterTarget = null;
          }

          if (!lastDragEnterTarget) {
            if (targetItemData) {
              lastDragEnterTarget = target;
            }
          }


          if (targetItemData && target) {
            if (targetItemData.type === 'seriesCourse') {
              var elementHeight = target.height();
              var elementOffsetY = event.pageY - target.offset().top;

              if (elementHeight / 2 > elementOffsetY) {
                target.css('border-bottom', 'none');
                target.css('border-top', 'solid 30px #D2D2D2');
              } else {
                target.css('border-top', 'none');
                target.css('border-bottom', 'solid 30px #D2D2D2');
              }
            } else if (targetItemData.type === 'seriesList') {
              seriesDropPosition.show();
            } else if (targetItemData.type === 'seriesListTop') {
              seriesDropPositionTop.show();
            }
          }
        }

        function dragEnd(event) {
          if (!isDragging) return;
          event.preventDefault();

          var dropTarget = lastDragEnterTarget;

          hideDragProxy();

          var dragInitiatorData = getDragItem(dragInitiator);

          if (dragInitiatorData.type === 'course') {
            dragInitiator.addClass('active-course');
            dragInitiator.removeClass('hideMe');
          } else {
            dragInitiator.show();
          }

          clearDraggingCursor();

          if (dropTarget) {
            var dropTargetData = getDragItem(dropTarget);
            var dropData = {
              from: {
                courseId: dragInitiatorData.id,
                type: dragInitiatorData.type
              },
              to: {
                courseId: dropTargetData.id,
                type: dropTargetData.type
              }
            };


            if (dropTargetData.type === 'seriesCourse') {
              lastDragEnterTarget.css('border-top', 'none');
              lastDragEnterTarget.css('border-bottom', 'none');

//              var elementHeight = dropTarget.height();
//              var elementOffsetY = event.pageY - dropTarget.offset().top;
//              console.log(elementHeight);
              var elementHeight = 34; // takes too long to calculate the height
              var elementOffsetY = event.pageY - dropTarget.offsetTop;
              if (elementHeight / 2 > elementOffsetY) {
                dropData.to.insertPosition = 'before';
              } else {
                dropData.to.insertPosition = 'after';
              }

            } else if (dropTargetData.type === 'seriesList') {
              seriesDropPosition.hide();
              dropData.to.insertPosition = 'after'
            } else if (dropTargetData.type === 'seriesListTop') {
              seriesDropPositionTop.hide();
              dropData.to.insertPosition = 'before';
            }

            scope.$apply(function () {
                scope.scopeDragDropFunction({$dragEvent: dropData});
              }
            );
          }

          lastDragEnterTarget = null;
          isDragging = false;
        }

        var dragEventInitializer = function (evt) {
          switch (evt.type) {
            case 'dragstart':
              dragStart(evt);
              break;
            case 'drag':
              drag(evt);
              break;
            case 'dragend':
              dragEnd(evt);
              break;
          }

          if (evt.isDefaultPrevented()) {
            evt.stopImmediatePropagation();
          }
        };

        iElement.bind('dragstart drag dragend', {
          click: true,
          distance: 3,
          handle: '[drag-start]'
        }, dragEventInitializer);

        scope.$on('$destroy', function () {
          iElement.unbind('dragstart drag dragend', dragEventInitializer);
        });
      }
    }
  }

})();
